export const engagementCampaignsCampaignTerritories = "/engagement/campaigns/campaign_territories";
